<div class="chat-grid p-3 pb-0 pt-0">
  <div class="conditional-pair-list-item-container" [ngClass]="{ 'pair-list-item-active': showPairInfoControl}" *ngIf="pair">
    <app-pair-list-item [pair]="pair"></app-pair-list-item>
  </div>
  <app-chat-session class="chat h-100" [user]="user" [chatGroupId]="chatGroupId" [conversation]="conversation"></app-chat-session>
  <app-chat-session-form class="typing" [user]="user" [chatGroupId]="chatGroupId" [conversation]="conversation"></app-chat-session-form>
</div>
